<template>
  <div class="content">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
      <aside v-if="ruleForm.commissionModel =='0'">
        <strong>{{ $t('app.agent.update.commissionNoteTitle') }}:</strong>
        <br />{{ $t('app.agent.update.commissionNote1') }} <br />{{ $t('app.agent.update.commissionNote2') }}
        <br />{{ $t('app.agent.update.commissionNote3') }} 
        <br />{{ $t('app.agent.update.commissionNote4') }}
      </aside>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('app.agent.update.nickname')" prop="username">
              <el-input v-model="ruleForm.username" :placeholder="$t('app.agent.update.enterNickname')" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('app.agent.update.companyName')" prop="companyName">
              <el-input v-model="ruleForm.companyName" :placeholder="$t('app.agent.update.enterCompanyName')" :disabled="!adminShow" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('app.agent.update.contactPerson')" prop="realName">
            <el-input v-model="ruleForm.realName" :placeholder="$t('app.agent.update.enterContactPerson')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('app.agent.update.contactPhone')" prop="phone">
            <el-input v-model="ruleForm.phone" :placeholder="$t('app.agent.update.enterPhone')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('app.agent.update.contactEmail')" prop="email">
            <el-input v-model="ruleForm.email" :placeholder="$t('app.agent.update.enterEmail')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('app.agent.update.address')" prop="address">
            <el-input v-model="ruleForm.address" :placeholder="$t('app.agent.update.enterAddress')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('app.agent.update.commissionModel')" prop="commissionModel">
              <el-input  :value="userCommission" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('app.agent.update.role')" prop="roleIds">
            <el-select v-model="ruleForm.roleIds" :filterable="true" multiple placeholder="请选择角色" @change="$forceUpdate()" style="width:100%" >
              <el-option
                v-for="item in roleOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
      </el-row>

      <el-row  v-show="adminShow">
        <el-col :span="8">
          <el-form-item label="自动提现">
            <template slot="label">
              自动提现
              <el-tooltip content="自动提现开启后，请在角色中选择相应的权限" placement="top">
                  <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <el-switch v-model="ruleForm.autoWithdrawal" active-color="#13ce66" active-text="是" inactive-text="否" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="佣金提现开始时间">
            <template slot="label">
              佣金提现开始时间
              <el-tooltip content="自动提现开通后，设置佣金订单可以提现的起始日期，时间默认0时0分0秒，此日期之前的佣金数据系统默认设置为已提现" placement="top">
                  <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <el-date-picker
              v-model="ruleForm.withdrawalStartTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="开启优惠价格" prop="discountProduct" v-if="adminShow && ruleForm.commissionModel =='0'">
            <el-switch v-model="ruleForm.discountProduct" active-color="#13ce66" active-text="是" inactive-text="否" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开启日期比例分佣" prop="showTimeCommission" v-if="adminShow && ruleForm.commissionModel =='0'">
                <el-switch v-model="ruleForm.showTimeCommission" active-color="#13ce66" active-text="是" inactive-text="否" active-value="1" inactive-value="0" @change="dateSwitchChange($event)"></el-switch>
            </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="归属部门" prop="deptId" v-if="adminShow">
              <treeselect v-model="ruleForm.deptId" :options="deptOptions" :normalizer="normalizer" :show-count="true" placeholder="请选择归属部门" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="提醒日期" v-show="adminShow">
            <el-row>
              <el-col :span="11">
                <el-input v-model="ruleForm.deductionStart" placeholder="开始日期"></el-input>
              </el-col>
              <el-col :span="2">
                <span style="display: inline-block;width: 30px;text-align: center;">-</span>
              </el-col>
              <el-col :span="11">
                <el-input v-model="ruleForm.deductionEnd" placeholder="结束日期" ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="介绍人分成" v-show="adminShow">
            <el-row>
              <el-col :span="12">
                <el-cascader
                  ref="myCascader"
                  :options="agentoptions"
                  :props="{ checkStrictly: true ,emitPath : false,value : 'id'}"
                  :show-all-levels="false"
                  clearable
                  v-model="ruleForm.agentInviter.id"
                  filterable
                ></el-cascader>
              </el-col>
              <el-col :span="12">
                <el-input placeholder="分成金额" v-model="ruleForm.agentInviter.commissionRate"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                    <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="平台" v-show="adminShow">
            <el-select v-model="ruleForm.platformId" placeholder="请选择平台"  filterable  style="width:100%">
              <el-option v-for="item in platforms" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" v-if="adminShow && ruleForm.commissionModel!='2'">
          <el-form-item label="API扣款模式" prop="deductionsMode">
            <template v-if="ruleForm.commissionModel=='0'">
              <el-radio v-model="ruleForm.apiDeduction" label="1" > 套餐模式
                <el-tooltip content="代理商套餐列表价格扣除余额" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-radio>
              <el-radio v-model="ruleForm.apiDeduction" label="2"  >比例模式
                <el-tooltip content="代理商比例*套餐价格扣除余额" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-radio>
            </template>
            <template v-if="ruleForm.commissionModel=='1'">
              <el-radio v-model="ruleForm.apiDeduction" label="1"  > 套餐模式
                <el-tooltip content="代理商套餐列表价格扣除余额" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-radio>
              <el-radio v-model="ruleForm.apiDeduction" label="2"  > 底价模式
                <el-tooltip content="代理商套餐底价扣除余额" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-radio>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('app.agent.update.shareRatio')" v-show="ruleForm.commissionModel =='0'">
            <el-input v-model="ruleForm.shareRate" autocomplete="off"  :placeholder="$t('app.agent.update.enterShareRatio')" 
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                <template slot="append">%</template>
              </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="套餐组" v-show="adminShow && ruleForm.commissionModel =='0'">
            <el-select v-model="ruleForm.productGroupIds" placeholder="请选择套餐组" multiple filterable style="width:100%">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="日期比例" v-show="adminShow && ruleForm.showTimeCommission == '1'">
            <el-row>
              <el-col :span="10">
                <el-input type="text" v-model="month" name="tel" oninput="value=value.replace(/[^\d]/g,'')" maxlength="9"  placeholder="月份"/>
              </el-col>
              <el-col :span="10">
                <el-input type="text" v-model="rate" name="tel" oninput="value=value.replace(/[^\d]/g,'')" maxlength="3"  placeholder="比例"/>
              </el-col>
              <el-col :span="4">
                <el-button type="primary"  @click="monthAdd()" >添加</el-button>
              </el-col>
            </el-row>
            <el-table :data="dateCommissionList" style="width: 300px" v-if="dateCommissionList.length > 0">
              <el-table-column prop="month" label="月份" width="130" align="center"></el-table-column>
              <el-table-column prop="rate" label="比例" width="80" align="center"></el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="deleteStr(scope.$index)" style="width: 60px">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="业务员" v-show="adminShow">
            <el-select v-model="ruleForm.salesmanUserId" placeholder="请选择业务员" filterable style="width:100%">
              <el-option v-for="item in users" :key="item.userId" :label="'['+item.username+']'+'-'+item.realName" :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item style="text-align: center;margin-left:-420px;margin-top:30px;">
        <el-button type="primary" @click="submitForm()">提交</el-button>
        <el-button @click="close()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { usersRoleType } from "@/api/api.js";//用户角色类型
import { productGroup,agentTreeList,agentDetail } from "@/api/api.js"; //获取套餐组，获取分成代理商 ,重置密码
import { agentUpdate,adminPlatformList } from "@/api/api.js"; //编辑代理商，获取代理商数据
import { deptTreeSelect } from "@/api/api.js";//部门  角色
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  // name: "editorAgent",
  components: { Treeselect },
  data() {
    return {
      ruleForm: {
        commissionModel:"0",
        deductionsMode:"2",
        types:[],
        discountProduct:"0",
        showTimeCommission:"0",
        deptId:undefined,
        roleIds:[],
        productGroupIds:[],
        agentInviter:{
          id:undefined,
          commissionRate:undefined,
        },
      },
      options: [],
      agentoptions:[],
      deptOptions:[],
      // 角色选项
      roleOptions: [],
      // 按日期分佣
      rate:"",
      month:"",
      dateCommissionList:[],
      rules: {
        username: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          {
            min: 2,
            max: 14,
            message: "请输入2至14字母数字或汉字",
            trigger: "blur"
          }
        ],
        flowRatio:[
          { required: true, message: "请输入流量比例", trigger: "blur" },
          {
            validator: function(rule, value, callback) {
              if (/^([1]+\.\d{1,1}|[1])$/.test(value) == false) {
                callback(new Error("请输入正确的流量比例，例如1.1"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 11,
            message: "请输入6至11字母或者数字",
            trigger: "blur"
          }
        ],
        confirmpassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          {
            min: 6,
            max: 11,
            message: "请输入6至11字母或者数字",
            trigger: "blur"
          }
        ],
        realName: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        email: [
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }
        ],
        companyName:[
          { required: true, message: "请输入公司名", trigger: "blur" }
        ]
      },
      platforms:[],
      //用户信息
      users:[],
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    },
    userCommission(){
      let commission = this.ruleForm.commissionModel;
      return commission == '0' ? this.$t('app.agent.update.proportionMode') : ( commission== '1' ? this.$t('app.agent.update.floorPriceMode') : this.$t('app.agent.update.flowPoolMode'))
    },
    deductionsMode(){
      let deductionsMode = this.ruleForm.deductionsMode;
      return deductionsMode == '1' ? "预付款" : "非预付款";
    }
  },
  methods: {
    // 日期分佣切换
    dateSwitchChange(val){
      if(val != "1" && this.dateCommissionList.length > 0){
          this.$confirm('如需要关闭日期分佣开关，请先删除日期分佣比例', '提示', {
            showCancelButton: false,
            showClose:false,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.ruleForm.showTimeCommission = "1";
          }).catch(() => {
            this.ruleForm.showTimeCommission = "1";
          });
      }
    },
    //转换菜单数据结构
    normalizer (node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },
    // 获取数据
    getAgentDetail(){
       let userId = this.$route.query && this.$route.query.userId;
      agentDetail({userId : userId}).then(res=>{
        this.roleOptions = res.data.data.roles;
        this.ruleForm = res.data.data.agent;
        this.dateCommissionList = this.ruleForm.agentDateRates;
        if(this.adminShow){
          if(this.ruleForm.commissionModel === '0'){
            this.roleOptions = this.roleOptions.filter(itme=>itme.roleSort === "1" || itme.roleSort === "0")
          }
          if(this.ruleForm.commissionModel === '1'){
            this.roleOptions = this.roleOptions.filter(itme=>itme.roleSort === "2" || itme.roleSort === "0")
          }
          if(this.ruleForm.commissionModel === '2'){
            this.roleOptions = this.roleOptions.filter(itme=>itme.roleSort === "3" || itme.roleSort === "0")
          }
        }
      });
    },
    //提交数据
    submitForm() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.ruleForm.agentDateRates = this.dateCommissionList;
          this.ruleForm.id = this.$route.query.id;
          agentUpdate(this.ruleForm).then(res => {
            this.$modal.msgSuccess("编辑代理商成功");
            this.close();
          });
        }
      });
    },
        /** 关闭按钮 */
    close() {
      const obj = { path: "/partners/agent" };
      this.$tab.closeOpenPage(obj);
    },
    // 日期分成
    monthAdd(){
      if (!this.month || !this.rate) {
        return this.$message.error("请输入分成比例");
      };
      let obj = {
        month: this.month,
        rate: this.rate,
      };
      this.dateCommissionList.push(obj);
      this.month = "";
      this.rate = "";
    },
    
    // 删除日期分成
    deleteStr(index){
      this.dateCommissionList.splice(index, 1);
    },
    //介绍人分成
    agentTreeListMethod(){
        let userId = this.$route.query && this.$route.query.userId;
        let params = {
          userId:userId
        };
        agentTreeList().then((res) => {
          this.agentoptions = res.data.data;
          traverse(this.agentoptions);
          function traverse(obj){
            obj.forEach((item) => {
              item.label = '[' + item.value + ']' + item.label;
              if(item.children){
                traverse(item.children)
              } else {
                delete item.children;
              }
            });
          }
        });
    },
    productGroupMethod(){
      productGroup().then((res) => {
        this.options = res.data.data;
        this.options.forEach((item) => {
          item.name = '[' + item.id + ']' + item.name;
        });
      });
    },
    /** 查询部门下拉树结构 */
    getDeptTree() {
        deptTreeSelect().then(res => {
          this.deptOptions = res.data.data;
        });
    },
    selectPlatforms(){
      adminPlatformList().then(res=>{
          this.platforms = res.data.data;
      });
    },
    selectUsersRoleType(){
      usersRoleType({roleType:'3'}).then(res=>{
          this.users = res.data.data;
      });
    }
  },
  created() {
    if(this.adminShow){
      this.agentTreeListMethod();
      this.getDeptTree();
      this.productGroupMethod();
      this.selectPlatforms();
      this.selectUsersRoleType();
    }
    this.getAgentDetail();
  },
  mounted() {
  },
};
</script>
<style scoped>
  aside {
    background: #eef1f6;
    padding: 8px 24px;
    margin-bottom: 20px;
    border-radius: 2px;
    display: block;
    line-height: 32px;
    font-size: 16px;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    color: #2c3e50;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>

